
import {
  reliability,
  solutions,
  enterpriseServices,
  popularServices,
  questions,
} from "~/data/solutions";
import Modal from "~/components/rebranding/modal/Modal.vue";

export default {
  data() {
    return {
      activeSection: "",
      FormTitle: "",
      reliability,
      solutions,
      enterpriseServices,
      popularServices,
      questions,
    };
  },
  components: {
    Modal,
  },
  methods: {
    handleScroll(e) {
      if (document.documentElement.scrollTop > 550) {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center floating";
      } else {
        document.getElementsByClassName("sections")[0].classList =
          "sections d-flex align-center";
      }
    },
  },
  beforeMount() {
    if (window.innerWidth >= 960)
      window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (window.innerWidth >= 960)
      window.removeEventListener("scroll", this.handleScroll);
  },
  head() {
    return {
      title: "راهکارهای تخصصی آبالون | مهاجرت، زیرساخت و امنیت",
      meta: [
        {
          name: "description",
          content:
            "راهکارهای تخصصی آبالون | پیاده‌سازی زیرساخت ابری سازمانی | مهاجرت ابری، خدمات زیرساختی و راهکارهای امنیتی | طراحی سفارشی متناسب با نیاز‌های شما",
        },
        {
          name: "keywords",
          content:
            "راهکارهای تخصصی, مهاجرت ابری, راهکارهای امنیتی آبالون, خدمات زیرساختی",
        },
        {
          property: "og:url",
          content: "https://abalon.cloud/solutions",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:locale",
          content: "fa",
        },
        {
          property: "og:title",
          content: "راهکارهای تخصصی آبالون | مهاجرت، زیرساخت و امنیت",
        },
        {
          property: "og:description",
          content:
            "راهکارهای تخصصی آبالون | پیاده‌سازی زیرساخت ابری سازمانی | مهاجرت ابری، خدمات زیرساختی و راهکارهای امنیتی | طراحی سفارشی متناسب با نیاز‌های شما",
        },
        {
          property: "og:image",
          content: "/images/og-image.png",
        },
        {
          property: "og:logo",
          content: "/images/logo.svg",
        },
        {
          name: "twitter:card",
          content: "summary",
        },
        {
          name: "twitter:url",
          content: "https://abalon.cloud/solutions",
        },
        {
          name: "twitter:title",
          title: "راهکارهای تخصصی آبالون | مهاجرت، زیرساخت و امنیت",
        },
        {
          name: "twitter:description",
          content:
            "راهکارهای تخصصی آبالون | پیاده‌سازی زیرساخت ابری سازمانی | مهاجرت ابری، خدمات زیرساختی و راهکارهای امنیتی | طراحی سفارشی متناسب با نیاز‌های شما",
        },
        {
          name: "format-detection",
          content: "telephone=no",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://abalon.cloud/solutions",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "راهکارهای تخصصی آبالون چه تفاوتی با سرویس‌های عمومی ابری دارند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "راهکارهای تخصصی آبالون متناسب با الزامات سازمانی طراحی می‌شوند و شامل مهاجرت، زیرساخت، امنیت و پشتیبانی اختصاصی هستند. برخلاف سرویس‌های عمومی، این خدمات به‌صورت سفارشی‌سازی‌شده و با در نظر گرفتن نیازهای خاص هر سازمان پیاده‌سازی می‌شوند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا استفاده از راهکارهای تخصصی آبالون نیاز به تغییر کامل زیرساخت فعلی سازمان دارد؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "خیر. این راهکارها قابلیت پیاده‌سازی مرحله‌ای و سازگار با زیرساخت موجود را دارند تا استقرار‌ سامانه‌های امنیتی و زیرساختی یا حتی مهاجرت یا توسعه به سمت ابر بدون وقفه در عملیات جاری انجام شود.",
                },
              },
              {
                "@type": "Question",
                name: "چه سازمان‌هایی بیشترین بهره را از راهکارهای تخصصی آبالون می‌برند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "سازمان‌هایی که به امنیت پیشرفته، مدیریت متمرکز، و دسترسی پایدار در مقیاس سازمانی نیاز دارند، بیشترین ارزش را از این راهکارها دریافت می‌کنند. این خدمات به‌ویژه برای بانک‌ها، موسسات مالی، شرکت‌های بزرگ و نهادهای دولتی که با داده‌های محرمانه سروکار دارند مناسب هستند.",
                },
              },
              {
                "@type": "Question",
                name: "آیا راهکارهای تخصصی آبالون در بلندمدت قابل اعتماد هستند؟",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "بله، راهکارهای تخصصی آبالون با معماری پایدار و مقیاس‌پذیر طراحی شده‌اند تا همراه با رشد سازمان توسعه پیدا کنند. این راهکارها امکان گسترش منابع بدون محدودیت، ارتقا متناسب با نیازهای آینده و تضمین امنیت در تمام مراحل را فراهم می‌کنند.",
                },
              },
            ],
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org/",
            "@type": "Review",
            itemReviewed: {
              "@type": "CreativeWorkSeries",
              name: "خدمات تخصصی آبالون",
            },
            author: {
              "@type": "Person",
              name: "Amirhosein",
            },
            reviewRating: {
              "@type": "Rating",
              ratingValue: "4.9",
              bestRating: "5",
            },
            publisher: {
              "@type": "Organization",
              name: "Abalon Cloud Solutions",
            },
          },
        },
      ],
    };
  },
};
